(function () {
  'use strict';
  if (window.twiPanAtc) return;

  // THE ONE COPY OF THE ARTWORK. Change the pan here and only here. {u} makes the mask ids unique,
  // because the product button and the sticky-bar button can both carry a pan on one page.
  var PAN_SVG =
    '<svg class="twi-pan__pan" viewBox="0 0 33 33" aria-hidden="true" focusable="false"><defs><mask id="twipanshine{u}" maskUnits="userSpaceOnUse" x="-6" y="-6" width="45" height="45"><rect x="-6" y="-6" width="45" height="45" fill="#fff"/><path class="twi-pan__shine" d="M21.12 24.83 A6.2 6.2 0 0 0 24.83 16.88" fill="none" stroke="#000" stroke-width="1.6" stroke-linecap="round" stroke-dasharray="5.95 20"/><circle class="twi-pan__glint" cx="18.8" cy="25.25" r=".85" fill="#000"/></mask>' +
    '<mask id="twipanhole{u}" maskUnits="userSpaceOnUse" x="-8" y="-8" width="50" height="50"><rect x="-8" y="-8" width="50" height="50" fill="#fff"/><ellipse cx="34.4" cy="19" rx="1.25" ry=".85" fill="#000"/></mask>' +
    '</defs>' +
    '<g class="twi-pan__spin"><circle cx="19" cy="19" r="9.1" fill="currentColor" mask="url(#twipanshine{u})"/><g transform="rotate(-138 19 19)"><g class="twi-pan__handle" mask="url(#twipanhole{u})"><path d="M25.6 16.8 L33 17.25 L33 20.75 L25.6 21.2 Z" fill="currentColor"/><circle cx="34.2" cy="19" r="2.3" fill="currentColor"/></g></g></g></svg>';
  var TICK_SVG =
    '<svg class="twi-pan__tick" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // over 90deg; the CSS dash length shows 55deg at rest (same look as before) and stretches/snaps with the handle.
  var TXT_ADDING = 'Adding…';
  var TXT_ADDED = 'Added';
  var TXT_STATUS = 'Added to your cart';
  var LANDING_CAP = 1300; // ms: one full toss; the toss in flight always finishes at its own speed
  var TICK_BEAT = 450; // ms: tick + "Added" shown before the theme's next step (e.g. the /cart redirect)
  var HOLD = 1600; // ms: how long "Added" stays when the shopper remains on the page
  var ICON_HOLD = 600; // ms: the tick is held this long on round icon-only buttons, once it has drawn
  var TICK_DRAW = 340; // ms: tickdraw (300) + its own 40 ms lead
  var ICON_FADE = 180; // ms: tick -> "+" crossfade on round buttons
  var FADE = 140; // ms: label crossfade

  var uid = 0;
  var stickyPending = null; // sticky-bar button that started the current add, if any
  var statusEl = null;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function st(b) {
    if (!b._twiPan) b._twiPan = { gen: 0, timers: [], phase: 'idle', minW: null };
    return b._twiPan;
  }
  function later(b, fn, ms) {
    var s = st(b), g = s.gen;
    s.timers.push(setTimeout(function () { if (st(b).gen === g) fn(); }, ms));
  }
  function reset(b) {
    var s = st(b);
    s.gen++;
    s.timers.forEach(clearTimeout);
    s.timers = [];
    return s;
  }

  function ensureStatus() {
    if (statusEl || !document.body) return statusEl;
    statusEl = document.createElement('span');
    statusEl.className = 'visually-hidden twi-pan-status';
    statusEl.setAttribute('role', 'status');
    statusEl.setAttribute('aria-live', 'polite');
    document.body.appendChild(statusEl);
    return statusEl;
  }
  function announce(text) {
    var el = ensureStatus();
    if (!el) return;
    el.textContent = '';
    setTimeout(function () { el.textContent = text; }, 60);
    setTimeout(function () { if (el.textContent === text) el.textContent = ''; }, 4000);
  }

  function overlay(b) {
    var o = b.querySelector(':scope > .twi-pan');
    if (!o) {
      uid++;
      o = document.createElement('span');
      o.className = 'twi-pan';
      o.setAttribute('aria-hidden', 'true');
      o.innerHTML = '<span class="twi-pan__icon">' + PAN_SVG.replace(/\{u\}/g, uid) + TICK_SVG + '</span><span class="twi-pan__lbl"></span>';
      b.insertBefore(o, b.firstChild); // first child: Dawn hides siblings AFTER a visible .loading__spinner
    }
    return o;
  }
  function label(b, text, cb) {
    var l = b.querySelector(':scope > .twi-pan .twi-pan__lbl');
    if (!l) return;
    if (reduced() || !l.textContent) { l.textContent = text; if (cb) cb(); return; }
    l.classList.add('is-out');
    later(b, function () { l.textContent = text; l.classList.remove('is-out'); if (cb) cb(); }, FADE);
  }

  function lockWidth(b) {
    // The full-width product button cannot resize; the sticky button sizes to its text, so pin it.
    if (b.classList.contains('button--full-width')) return;
    var s = st(b);
    if (s.minW === null) s.minW = b.style.minWidth || '';
    b.style.minWidth = Math.ceil(b.getBoundingClientRect().width) + 'px';
  }
  function unlockWidth(b) {
    var s = st(b);
    if (s.minW !== null) { b.style.minWidth = s.minW; s.minW = null; }
  }

  function clean(b) {
    reset(b).phase = 'idle';
    b.classList.remove('twi-pan-on', 'twi-pan-busy', 'twi-pan-added', 'twi-pan-leaving');
    b.style.removeProperty('--twi-tick-delay');
    b.removeAttribute('aria-busy');
    var l = b.querySelector(':scope > .twi-pan .twi-pan__lbl');
    if (l) { l.textContent = ''; l.classList.remove('is-out'); }
    unlockWidth(b);
  }

  function begin(b) {
    var s = reset(b);
    s.phase = 'busy';
    // The button's own text colour, read before its label is hidden, so the pan matches any button
    // (Dawn primary/secondary, the sticky bar, custom buttons with !important colours).
    var ink = getComputedStyle(b).color;
    lockWidth(b);
    var o = overlay(b);
    if (ink && !/rgba\(\d+, \d+, \d+, 0\)|transparent/.test(ink)) o.style.color = ink;
    b.classList.toggle('twi-pan-iconly', !(b.textContent || '').trim()); // icon-only buttons: pan, no words
    b.classList.remove('twi-pan-added', 'twi-pan-leaving');
    b.classList.add('twi-pan-on', 'twi-pan-busy');
    b.setAttribute('aria-busy', 'true');
    var l = b.querySelector(':scope > .twi-pan .twi-pan__lbl');
    l.classList.remove('is-out');
    l.textContent = TXT_ADDING;
  }

  // How long the round button's circle takes to come back: the same transition it left with (reversed).
  function circleMs(b) {
    var cs = getComputedStyle(b), props = (cs.transitionProperty || '').split(','), durs = (cs.transitionDuration || '').split(',');
    var max = 0;
    for (var i = 0; i < props.length; i++) {
      var pn = props[i].trim(), d = durs[i % durs.length] || '0s';
      if (!/^(all|border|border-color|background|background-color|box-shadow)$/.test(pn)) continue;
      var ms = parseFloat(d) * (/ms$/.test(d.trim()) ? 1 : 1000);
      if (ms > max) max = ms;
    }
    return Math.min(max, 400);
  }

  function showAdded(b, staying, after, real) {
    var s = reset(b);
    s.phase = 'added';
    var iconly = b.classList.contains('twi-pan-iconly');
    var back = iconly && !reduced() ? circleMs(b) : 0;
    if (iconly) b.style.setProperty('--twi-tick-delay', (back + 40) + 'ms');
    b.classList.remove('twi-pan-busy');
    b.removeAttribute('aria-busy');
    b.classList.add('twi-pan-added');
    label(b, TXT_ADDED);
    if (!staying) return; // the theme is navigating to /cart, which announces the add itself
    later(b, function () {
      b.classList.add('twi-pan-leaving'); // overlay fades out, the button's own label fades back in
      later(b, function () {
        clean(b);
        if (b !== real && b.classList.contains('twi-sticky__b')) restoreSticky(b, real);
        if (after) after(b);
      }, reduced() ? 0 : (iconly ? ICON_FADE + 20 : 220));
    }, iconly ? (reduced() ? ICON_HOLD : back + TICK_DRAW + ICON_HOLD) : HOLD);
  }

  // Buttons animating for this add: the button itself, plus the sticky-bar button when the shopper
  // used the bar (or the bar is showing).
  function group(btn) {
    var out = [btn];
    var sid = (btn.id || '').replace('ProductSubmitButton-', '');
    var sb = sid ? document.getElementById('twiStickyAdd-' + sid) : null;
    var bar = sb ? sb.closest('.twi-sticky') : null;
    if (sb && (sb === stickyPending || (bar && bar.classList.contains('is-visible')))) out.push(sb);
    return out;
  }
  // The set chosen at start() is remembered, so a bar that hides mid-request is still restored.
  function started(btn) {
    return btn._twiPanGroup || [];
  }
  function activeGroup(btn) {
    return started(btn).filter(function (b) { return st(b).phase === 'busy'; });
  }

  function start(btn) {
    try {
      var list = group(btn);
      btn._twiPanGroup = list;
      list.forEach(begin);
      stickyPending = null;
    } catch (e) { /* never break Add to cart */ }
  }

  // then:  the theme's own next step after a successful add (e.g. go to /cart). Runs once the pan lands.
  // after: for pages that stay put, runs after "Added" has been shown and cleared (per button).
  function done(btn, then, after) {
    var list = [];
    try { list = activeGroup(btn); } catch (e) { list = []; }
    // Claimed now, so the request's finally (end) does not undo a success still waiting to land.
    list.forEach(function (b) { st(b).phase = 'landing'; });
    var fired = false;
    function land() {
      if (fired) return;
      fired = true;
      try { list.forEach(function (b) { showAdded(b, !then, after, btn); }); } catch (e) {}
      if (!then) announce(TXT_STATUS);
      if (then) { if (list.length && !reduced()) setTimeout(then, TICK_BEAT); else then(); }
      if (after && !list.length) after(btn);
    }
    if (!list.length || reduced()) return land();
    // Let the toss in flight land at its natural speed before switching (never cut off mid-air).
    var spin = list[list.length - 1].querySelector('.twi-pan__spin');
    if (spin) spin.addEventListener('animationiteration', land, { once: true });
    setTimeout(land, LANDING_CAP);
  }

  function end(btn) {
    try {
      started(btn).forEach(function (b) {
        if (st(b).phase !== 'busy') return; // succeeded: showAdded owns the rest
        clean(b);
        if (b.classList.contains('twi-sticky__b')) restoreSticky(b, btn);
      });
    } catch (e) {}
  }

  // The bar wrote "Adding..." and disabled itself for 6 s before clicking the real button. After a
  // failed add, give it the real button's label back at once so it is usable again.
  function restoreSticky(sb, real) {
    var span = real && real.querySelector(':scope > span:not(.twi-pan)');
    var txt = span ? (span.textContent || '').trim() : '';
    if (!real || !txt || real.disabled) return;
    sb.textContent = txt;
    sb.setAttribute('aria-label', txt + ', quick add bar');
    sb.disabled = false;
  }

  // Capture phase runs before the bar's own click handler rewrites its label, so the width is
  // measured on "Add to cart", not on the shorter "Adding...".
  document.addEventListener('click', function (e) {
    var sb = e.target && e.target.closest ? e.target.closest('.twi-sticky__b') : null;
    if (!sb || sb.disabled) return;
    stickyPending = sb;
    lockWidth(sb);
    setTimeout(function () {
      if (stickyPending === sb) stickyPending = null;
      if (st(sb).phase === 'idle') unlockWidth(sb); // not an add (e.g. notify-me): release
    }, 0);
  }, true);

  // Book pages (custom format hub) use a plain <form class="twi-buy-form"> that the browser posts to /cart/add,
  // then lands on /cart. There is no request to hook, so the pan simply spins until the page changes, and a
  // second click while it is posting is ignored (a double submit would add the book twice).
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.classList || !f.classList.contains('twi-buy-form')) return;
    var b = f.querySelector('button[type="submit"]');
    if (!b) return;
    if (st(b).phase === 'busy') { e.preventDefault(); return; }
    try { begin(b); } catch (err) {}
  });

  // ---- Every other theme loader (cart line quantity/remove, quick-add opener, facets, predictive
  // search, quantity rules): Dawn renders one <svg class="spinner"> from snippets/loading-spinner.liquid.
  // Swap it for the pan (spin + handle flex, no tick, no label), including in sections Dawn re-renders.
  function panLoaders(root) {
    var list = (root || document).querySelectorAll('svg.spinner:not(.twi-pan__pan)');
    for (var i = 0; i < list.length; i++) {
      var old = list[i];
      if (!old.parentNode) continue;
      uid++;
      var tmp = document.createElement('span');
      tmp.innerHTML = PAN_SVG.replace(/\{u\}/g, 'l' + uid);
      var svg = tmp.firstChild;
      svg.setAttribute('class', 'spinner twi-pan__pan twi-pan-loader');
      svg.setAttribute('viewBox', '0 0 38 38'); // centred on the pan (19,19), so it sits in the middle of its spot
      old.parentNode.replaceChild(svg, old);
    }
  }
  // .twi-line-stack (a one-cell grid, see the CSS) so the pan takes the total's exact place. Dawn replaces the whole
  // cart HTML when /cart/change returns, so a line that was busy is re-stacked on arrival with .twi-line-landing: the
  // pan keeps tossing (same phase), lands (cap LINE_CAP), then the pan fades out as the new price fades in.
  // Dawn's own JS still finds the spinner (#CartItem-N .loading__spinner) and toggles .hidden on it as before.
  var TOSS = 1300, LINE_CAP = 400;
  var lineBusy = {}; // "CartItem-1:d" -> time the line's spinner was shown
  function lineKey(sp) {
    var row = sp.closest && sp.closest('.cart-item');
    var td = sp.closest && sp.closest('.cart-item__totals');
    if (!row || !row.id || !td) return null;
    return row.id + (td.classList.contains('small-hide') ? ':d' : ':m');
  }
  function lineSig(sp) {
    var row = sp.closest && sp.closest('.cart-item'), a = row && row.querySelector('.cart-item__name');
    return a ? (a.getAttribute('href') || '') + '|' + (a.textContent || '').trim() : '';
  }
  function lineLand(stack, t0) {
    var phase = (Date.now() - t0) % TOSS;
    stack.classList.add('twi-line-landing');
    var parts = stack.querySelectorAll('.twi-pan__spin, .twi-pan__handle, .twi-pan__shine, .twi-pan__glint');
    for (var i = 0; i < parts.length; i++) parts[i].style.animationDelay = -phase + 'ms';
    setTimeout(function () { stack.classList.remove('twi-line-landing'); }, Math.max(30, Math.min(LINE_CAP, TOSS - phase)));
  }
  function stackLines(root) {
    var list = (root || document).querySelectorAll('.cart-item__totals > .loading__spinner');
    for (var i = 0; i < list.length; i++) {
      var sp = list[i], td = sp.parentNode, pw = sp.nextElementSibling;
      if (!pw || !pw.classList.contains('cart-item__price-wrapper')) continue;
      var stack = document.createElement('div');
      stack.className = 'twi-line-stack';
      td.insertBefore(stack, sp);
      stack.appendChild(sp);
      stack.appendChild(pw);
      var svg = sp.querySelector('svg.twi-pan-loader');
      if (svg) svg.setAttribute('viewBox', '9.9 9.9 18.2 18.2'); // the pan's circle fills the box; the handle draws outside
      var k = lineKey(sp);
      if (k && lineBusy[k]) {
        var b0 = lineBusy[k];
        delete lineBusy[k];
        // only the SAME item lands: after a remove, line N is the next product, whose total just shows
        if (!reduced() && b0.sig === lineSig(sp)) lineLand(stack, b0.t);
      }
    }
  }
  function lineSpinnerChanged(sp) {
    var stack = sp.parentNode;
    if (!stack || !stack.classList || !stack.classList.contains('twi-line-stack') || stack.classList.contains('twi-line-landing')) return;
    var k = lineKey(sp);
    if (!k) return;
    if (!sp.classList.contains('hidden')) { if (!lineBusy[k]) lineBusy[k] = { t: Date.now(), sig: lineSig(sp) }; }
    else if (sp.isConnected) delete lineBusy[k]; // error or no re-render: CSS fades the price back
  }

  // Buttons Dawn puts into 'loading' without an add (the grid's quick-add opener for products with options,
  // which loads the options popup): same pan, same place, with the button's own label. No tick: nothing was added.
  function loadingButton(b) {
    if (!b.matches('.button, button') || b.classList.contains('twi-pan-on') && st(b).phase !== 'loader') return;
    if (b.classList.contains('loading')) {
      if (st(b).phase !== 'idle') return;
      var txt = '';
      for (var k = 0; k < b.childNodes.length; k++) { var n = b.childNodes[k]; if (n.nodeType === 3 || (n.nodeType === 1 && n.tagName === 'SPAN' && !n.classList.contains('twi-pan'))) txt += n.textContent; }
      txt = txt.replace(/\s+/g, ' ').trim();
      if (!txt) return;
      begin(b);
      st(b).phase = 'loader';
      b.querySelector(':scope > .twi-pan .twi-pan__lbl').textContent = txt;
    } else if (st(b).phase === 'loader') {
      clean(b);
    }
  }
  function watchLoaders() {
    panLoaders(document);
    stackLines(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].type === 'attributes') {
          var tg = ms[i].target;
          if (tg.nodeType !== 1) continue;
          if (tg.classList.contains('loading__spinner')) { lineSpinnerChanged(tg); continue; }
          loadingButton(tg);
          continue;
        }
        for (var j = 0; j < ms[i].addedNodes.length; j++) {
          var n = ms[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('svg.spinner') || n.querySelector('svg.spinner'))) { panLoaders(n.parentNode || n); }
          if (n.nodeType === 1 && (n.matches('.cart-item, .cart-items, .cart-item__totals') || n.querySelector('.cart-item__totals'))) { stackLines(n.parentNode || n); }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  // Back button from /cart can restore this page from the back/forward cache mid-animation.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var on = document.querySelectorAll('.twi-pan-on');
    for (var i = 0; i < on.length; i++) clean(on[i]);
  });

  function boot() { ensureStatus(); try { watchLoaders(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.twiPanAtc = { start: start, done: done, end: end };
})();
